import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotifications } from '../../context/NotificationContext';
import { getNotificationLink } from '../../utils/notificationMeta';

const useOpenNotification = () => {
    const navigate = useNavigate();
    const { markRead } = useNotifications();

    return useCallback((notification) => {
        if (!notification.isRead) markRead(notification.id);

        const link = getNotificationLink(notification);
        if (link) navigate(link);
    }, [markRead, navigate]);
};

export default useOpenNotification;
